import * as clientActionTypes from "../../Constants/clientActionTypes";
import { StatisticLabel } from "semantic-ui-react";

export const initialState = {
    loading: false,
    isLoading: false,
    error: null,
    isMappedClient: false,
    clientLookUpDetails: {},
    integrationType: {},
    requiredTaxToBeLinkedData: {},
    documentSyncLookUpDetails: ''
};

const clientReducer = (state = initialState, action) => {
    switch (action.type) {

        case clientActionTypes.GET_CLIENT_MAPPED_DATA:
            return {
                ...state,
                isMappedClient: action.payload.isClientMapped
            };
        case clientActionTypes.GET_CLIENT_LINKING_DATA:
            return {
                ...state,
                clientLookUpDetails: action.payload.clientLookUpData,
            };
        case clientActionTypes.GET_TAX_NOT_LINKED_DATA:
            return {
                ...state,
                requiredTaxToBeLinkedData: action.payload.mappedTaxToBeLinkedData,
            };
        case clientActionTypes.GET_FIRM_DOCUMENT_SYNC:
            return {
                ...state,
                documentSyncLookUpDetails: action.payload.documentSyncLookUpData,
            };
        default:
            return state;
    }
};

export default clientReducer;
